var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyevisibleoff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#22272A",
    d: "M10.742 3.508C9.903 3.18 8.996 3 8.05 3 4.755 3 1.94 5.177.8 8.25c.549 1.478 1.484 2.75 2.675 3.67m.81.549C5.4 13.126 6.683 13.5 8.05 13.5c3.295 0 6.11-2.177 7.25-5.25-.681-1.836-1.96-3.353-3.583-4.276m-1.592 1.77c.633.605 1.032 1.481 1.032 2.456 0 1.822-1.392 3.3-3.107 3.3-.812 0-1.552-.332-2.106-.874m-.644-.89c-.228-.459-.357-.982-.357-1.536 0-1.822 1.392-3.3 3.107-3.3.4 0 .782.08 1.133.227M1.5 15.5L14.289.898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyevisibleoff);
export default __webpack_public_path__ + "static/media/eyevisibleoff.70f5905c8367761c7214897cbc98bef7.svg";
export { ForwardRef as ReactComponent };